var map = {
	"./dankoff/dankoff_logo.png": "3fb3",
	"./hermelin/hermelin_brand_logo.png": "b9db",
	"./hermelin/hermelin_logo.png": "a6f9",
	"./images/dankoff_logo.png": "3215",
	"./images/hermelin_brand_logo.png": "5c43",
	"./images/slow_logo.png": "59aa",
	"./slow/slow_brand_logo.png": "9ea0",
	"./slow/slow_logo.png": "cc1f"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "08ce";